import { useEffect, useState, useCallback } from 'react';
import { Select } from 'antd';

//* Style
import CustomSelectStyle from './style';

const CustomSelect = ({
	value,
	defaultValue,
	className,
	size,
	onChange,
	placeholder,
	allowClear,
	suffixIcon,
	children,
	...props
}) => {
	// const [isOpen, setIsOpen] = useState(false)

	// useEffect(() => {
	//     window.addEventListener('scroll', handleScroll)

	//     return () => {
	//         window.removeEventListener('scroll', handleScroll)
	//     }
	// }, [])

	// const handleScroll = useCallback(() => {
	//     setIsOpen(false)
	// }, [])

	return (
		<CustomSelectStyle>
			<Select
				size={size}
				// open={isOpen}
				value={value}
				onChange={onChange}
				allowClear={allowClear}
				suffixIcon={suffixIcon}
				placeholder={placeholder}
				defaultValue={defaultValue}
				className={className || ''}
				getPopupContainer={(trigger) => trigger.parentNode}
				// onDropdownVisibleChange={() => setIsOpen(!isOpen)}
				{...props}>
				{children}
			</Select>
		</CustomSelectStyle>
	);
};

export default CustomSelect;
